<template>
  <b-card>
    <b-tabs>





      <!--  ==============================  FIRST_TAB START ============================== -->
      <b-tab active :title="$t('by_materials')">
            
        <div class="d-flex justify-content-between align-items-center">


          <div class="d-flex align-items-center">
          
            <h3 class="mr-2">
              {{$t('sidebar.good_report')}}
            </h3>

            <b-row style="min-width: 800px;">


              <!--  ==============================  FILTERS START ============================== -->
              <b-col md="4">
                <b-form-group :label="$t('reference.categoriya')">
                    <v-select
                      v-model="goods.category"
                      label="title"
                      :options="product_categories"
                      @input="materialTypeGetByCategory"
                    />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group :label="$t('table.product_type')">
                    <v-select
                      v-model="goods.title"
                      label="title"
                      :options="GET_MATERIALS.results"
                      :filterable="false"
                      @input="materialGet"
                      @search="onSearch1"
                    >
                      <li slot="list-footer" class="pagination">
                        <button :disabled="!GET_MATERIALS.previous" @click="previous()">
                          {{ $t("prev") }}
                        </button>
                        <button :disabled="!GET_MATERIALS.next" @click="nextFunc()">
                          {{ $t("next") }}
                        </button>
                      </li>
                    </v-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group :label="$t('nomenclature')">
                    <v-select
                      v-model="goods.good_id"
                      :options="GET_MATERIALS_TABLE_ID.results"
                      :filterable="false"
                      @search="onSearch"
                      @input="onGoodSelected"
                      label="value"
                    >
                      <li slot="list-footer" class="pagination">
                        <button
                          :disabled="!GET_MATERIALS_TABLE_ID.previous"
                          @click="previousTableId()"
                        >
                          {{ $t("prev") }}
                        </button>
                        <button
                          :disabled="!GET_MATERIALS_TABLE_ID.next"
                          @click="nextTableId()"
                        >
                          {{ $t("next") }}
                        </button>
                      </li>
                    </v-select>
                </b-form-group>
              </b-col>

          

              <!--  ==============================  FILTERS END ============================== -->


            </b-row>

          </div>

          

          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-model="goods.show_archive"
              name="check-button"
              @input="onGoodSelected"
              switch
              inline
              class="m-1"
            >
              {{$t('archive')}}
            </b-form-checkbox>
  
  
            <b-button
              :title="$t('excel')"
              size="sm"
              variant="success"
              class="m-1"
              @click="downloadExcel()"
            >
              <feather-icon icon="DownloadIcon" size="15" />
            </b-button>
          </div>





        </div>
        

        <!--  ==============================  TABLE START ============================== -->
        <b-table
          :items="items1"
          :fields="fields"
          small
          responsive
          bordered
          striped
          show-empty
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #table-busy>
            <div
              class="text-success my-2 d-flex justify-content-center align-items-center"
            >
              <b-spinner />
              <strong class="px-1">Loading...</strong>
            </div>
          </template>
          <template #empty>
            <div class="text-center text-danger my-2">
              <strong>
                {{ $t("objects.no_data") }}
              </strong>
            </div>
          </template>




          <template #cell(numeration)="props">
            {{ props.index + 1 }}
          </template>
          
          <template #cell(count)="props">
            {{ props.item && props.item.count ? $_formatPriceMixin(props.item.count) : 0 }}
          </template>
          <template #cell(price)="props">
            {{ props.item && props.item.count ? $_formatPriceMixin(props.item.price) : 0 }}
          </template>



          <template #custom-foot>
            <b-tr class="text-center">
              <b-th variant="info" class="text-white bg-info">
                <span></span>
              </b-th>
              <b-th variant="info" class="text-left text-white bg-info">
                <span>Жами</span>
              </b-th>
              <b-th variant="info" class="text-white bg-info">
                {{ $_formatPriceMixin(items1_total.count) }}
              </b-th>
              <b-th variant="info" class="text-white bg-info">
                {{ $_formatPriceMixin(items1_total.price) }}
              </b-th>
            </b-tr>
          </template>

        </b-table>
        <!--  ==============================  TABLE END ============================== -->





      </b-tab>
      <!--  ==============================  FIRST_TAB END ============================== -->












      <!--  ==============================  SECOND_TAB START ============================== -->
      <b-tab :title="$t('by_categories')">
            
        <div class="d-flex justify-content-between align-items-center">



          <div class="d-flex align-items-center">
          
            <h3 class="mr-2">
              {{$t('sidebar.good_category_report')}}
            </h3>

            <b-row style="min-width: 1100px;">





              <!--  ==============================  FILTERS START ============================== -->
              <b-col md="3">
                <b-form-group :label="$t('sidebar.warehouse')">
                    <v-select
                      v-model="goods.storage_id"
                      label="title"
                      :options="warehouseTable.results"
                      @input="onGoodSelected2"
                    >
                      <li slot="list-footer" class="pagination">
                        <button :disabled="!warehouseTable.previous" @click="previousStorage()">
                          {{ $t("prev") }}
                        </button>
                        <button :disabled="!warehouseTable.next" @click="nextStorage()">
                          {{ $t("next") }}
                        </button>
                      </li>
                    </v-select>  
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group :label="$t('reference.categoriya')">
                    <v-select
                      v-model="goods.category"
                      label="title"
                      :options="product_categories"
                      @input="materialTypeGetByCategory"
                    />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <!-- {{ GET_MATERIALS.results }} -->
                <b-form-group :label="$t('table.product_type')">
                    <v-select
                      v-model="goods.title"
                      label="title"
                      :options="GET_MATERIALS.results"
                      :filterable="false"
                      @input="materialGet"
                      @search="onSearch1"
                    >
                      <li slot="list-footer" class="pagination">
                        <button :disabled="!GET_MATERIALS.previous" @click="previous()">
                          {{ $t("prev") }}
                        </button>
                        <button :disabled="!GET_MATERIALS.next" @click="nextFunc()">
                          {{ $t("next") }}
                        </button>
                      </li>
                    </v-select>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group :label="$t('nomenclature')">
                    <v-select
                      v-model="goods.good_id"
                      :options="GET_MATERIALS_TABLE_ID.results"
                      :filterable="false"
                      @search="onSearch"
                      @input="onGoodSelected2"
                      label="value"
                    >
                      <li slot="list-footer" class="pagination">
                        <button
                          :disabled="!GET_MATERIALS_TABLE_ID.previous"
                          @click="previousTableId()"
                        >
                          {{ $t("prev") }}
                        </button>
                        <button
                          :disabled="!GET_MATERIALS_TABLE_ID.next"
                          @click="nextTableId()"
                        >
                          {{ $t("next") }}
                        </button>
                      </li>
                    </v-select>
                </b-form-group>
              </b-col>
              <!--  ==============================  FILTERS END ============================== -->






            </b-row>

          </div>

          





          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-model="goods.show_archive2"
              name="check-button"
              @input="onGoodSelected2"
              switch
              inline
              class="m-1"
            >
              {{$t('archive')}}
            </b-form-checkbox>
  
  
            <b-button
              :title="$t('excel')"
              size="sm"
              variant="success"
              class="m-1"
              @click="downloadExcel2()"
            >
              <feather-icon icon="DownloadIcon" size="15" />
            </b-button>
          </div>





        </div>
        

        <!--  ==============================  TABLE START ============================== -->
        <b-table
          :items="items2"
          :fields="fields2"
          small
          responsive
          bordered
          striped
          show-empty
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #table-busy>
            <div
              class="text-success my-2 d-flex justify-content-center align-items-center"
            >
              <b-spinner />
              <strong class="px-1">Loading...</strong>
            </div>
          </template>

          <template #empty>
            <div class="text-center text-danger my-2">
              <strong>
                {{ $t("objects.no_data") }}
              </strong>
            </div>
          </template>
          




          <template #cell(numeration)="props">
            {{ props.index + 1 }}
          </template>
          
          <template #cell(category)="props">
            {{ props.item.category[$i18n.locale] }}
          </template>
          <template #cell(count)="props">
            {{ $_formatPriceMixin(props.item.count) }}
          </template>
          <template #cell(price)="props">
            {{ $_formatPriceMixin(props.item.price) }}
          </template>




          <template #custom-foot>
            <b-tr class="text-center">
              <b-th variant="info" class="text-white bg-info">
                <span></span>
              </b-th>
              <b-th variant="info" class="text-white text-left bg-info">
                <span>Жами</span>
              </b-th>
              <b-th variant="info" class="text-white bg-info">
                {{ $_formatPriceMixin(items2_total.count) }}
              </b-th>
              <b-th variant="info" class="text-white bg-info">
                {{ $_formatPriceMixin(items2_total.price) }}
              </b-th>
            </b-tr>
          </template>
          
        </b-table>
        <!--  ==============================  TABLE END ============================== -->




      </b-tab>
      <!--  ==============================  SECOND_TAB END ============================== -->








    </b-tabs>
    
  </b-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { BCard, BSpinner, BTr, BTh, BTable, BButton, BFormGroup, BRow, BCol, BFormInput, BFormTextarea, BModal, BTabs, BTab, BFormCheckbox, } from "bootstrap-vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import moment from 'moment'
import VueDataPicker from "@/components/VueDatePicker.vue";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
    BButton,
    BFormGroup,
    VueDataPicker,
    vSelect,
    BRow,
    BCol,
    BFormInput, 
    BFormTextarea, 
    BModal,
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
    BFormCheckbox,
  },
  mixins: [priceFormatMixin],

  data() {
    return {
      loader: true,
      items1: [],
      items2: [],
      items1_total: {},
      items2_total: {},

    


      fields: [
        {
          key: "numeration",
          label: "№",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
        {
          key: "object",
          label: "Объект номи",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
        {
          key: "count",
          label: "сони",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
        {
          key: "price",
          label: "суммаси",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
      ],
      fields2: [
        {
          key: "numeration",
          label: "№",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
        {
          key: "category",
          label: "material_categories",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
        {
          key: "count",
          label: "сони",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
        {
          key: "price",
          label: "суммаси",
          thClass: "text-center bg-info text-white",
          tdClass: "text-center",
        },
      ],




      getMaterial: [],

      search: "",
      search1: "",

      goods: {
        id: null,
        brigade: null,
        category: null,
        title: null,
        good_id: null,
        storage_id: null,
        count: null,
        comment: null,
        show_archive: true,
        show_archive2: true,
      },

      storagePage: 1,




    };
  },

  computed: {
    ...mapState("application", ["report_requirement_for_good", "report_requirement_for_good_material_type"]),
    ...mapState("obectsWarehouse", ["warehouseTable"]),
    ...mapGetters("materials", [
      "GET_MATERIALS",
      "GET_MATERIALS_TABLE_ID",
      "GET_PRODUCT_CATEGORIES",
    ]),
    product_categories: {
      get: function () {
        return this.$store.state.materials.product_categories;
      },
      set: function (newValue) {
        this.$store.commit('materials/SET_PRODUCT_CATEGORIES', newValue)
      }
    },

   
  },

  async mounted() {





    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.onGoodSelected('')
    await this.onGoodSelected2('')


    // this.items1 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD()
    // this.items1_total = this.items1.find(item => item.object == 'Общий');
    // this.items1 = this.items1.filter(item => item.object != 'Общий');
    


    // this.items2 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE()
    // this.items2_total = this.items2.find(item => item?.category?.ru == 'Общий');
    // this.items2 = this.items2.filter(item => item?.category?.ru != 'Общий');



    await this.FETCH_PRODUCT_CATEGORIES({ mini: true });
    this.product_categories.unshift({
      id: null,
      title: this.$i18n.locale == "ru" ? "Все" : "Barchasi",
    });
    
    await this.FETCH_WAREHOUSE_TABLE({ is_object: true })
    // ===============  PRIMARY_REQUESTS_SECTION END ===============




    
  },

  methods: {
    ...mapActions("application", ["FETCH_REPORT_REQUIREMENT_FOR_GOOD", "FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE"]),
    ...mapActions("materials", [
      "FETCH_MATERIALS_TABLE_ID",
      "FETCH_PRODUCT_CATEGORIES",
      "FETCH_MATERIALS",
    ]),
    ...mapActions('obectsWarehouse', ['FETCH_WAREHOUSE_TABLE']),













    // ===============  PAGINATION_SECTION START ===============
    async previousTableId() {
      if (this.GET_MATERIALS_TABLE_ID.previous) {
        const page = this.GET_MATERIALS_TABLE_ID.previous;

        await this.FETCH_MATERIALS_TABLE_ID({
          product: this.goods && this.goods.title && this.goods.title.id ? 
          this.goods.title.id : null,
          page: page,
          pagination: "number",
          search: this.search
        });
      }
    },

    async nextTableId() {
      if (this.GET_MATERIALS_TABLE_ID.next) {
        const page = this.GET_MATERIALS_TABLE_ID.next;

        await this.FETCH_MATERIALS_TABLE_ID({
          product: this.goods && this.goods.title && this.goods.title.id ? 
          this.goods.title.id : null,
          page: page,
          pagination: "number",
          search: this.search
        });
      }
    },

    async previous() {
      if (this.GET_MATERIALS.previous) {
        const page = this.GET_MATERIALS.previous;

        await this.FETCH_MATERIALS({ 
          category: this.goods && this.goods.category 
          && this.goods.category.id ? this.goods.category.id : null,
          page: page, 
          pagination: "number",
        });
      }
    },

    async nextFunc() {
      if (this.GET_MATERIALS.next) {
        const page = this.GET_MATERIALS.next;

        await this.FETCH_MATERIALS({ 
          category: this.goods && this.goods.category && this.goods.category.id ?
           this.goods.category.id : null,
          page: page, 
          pagination: "number",
        });
      }
    },
    async previousStorage() {
      if (this.warehouseTable.previous) {
        this.storagePage--;

        await this.FETCH_WAREHOUSE_TABLE({ is_object: true, page: this.storagePage });
      }
    },
    async nextStorage() {
      if (this.warehouseTable.next) {
        this.storagePage++;

        await this.FETCH_WAREHOUSE_TABLE({ is_object: true, page: this.storagePage });
      }
    },
    // ===============  PAGINATION_SECTION END ===============


















    // ===============  MATERIAL_GET_SECTION START ===============
    async materialTypeGetByCategory(data) {
      if (data.id == 0) {
        await this.FETCH_MATERIALS({ pagination: "number" });
      } else {
        await this.FETCH_MATERIALS({ 
          category: data.id, 
          pagination: "number",
        });
      }
      // this.items1 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD({category: this.goods.category})
      // this.items2 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE()
    },
    async materialGet(data) {
      if (!data) {
        this.getMaterial = [];
      } else {
        await this.FETCH_MATERIALS_TABLE_ID({
          product: data.id,
          pagination: "number",
        });
      }
      
      if(data.category && data.category.id && data.category.title){
        // if(this.goods.category == '' || this.goods.category == null){
          // this.goods.title = {id: data.product.id, title: data.product.title}
          this.goods.category = {id: data.category.id, title: data.category.title}
        // }
      }

      // this.items1 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD()



      let params = {}
      if(this.goods && this.goods.title && this.goods.title.id){
        params.product_id = this.goods.title.id
      } 
      
      if(this.goods && this.goods.storage_id && this.goods.storage_id.id){
        params.storage_id = this.goods.storage_id.id
      } 


      this.items2 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE(params)

      this.items2_total = this.items2.find(item => item?.category?.ru == 'Общий');
      this.items2 = this.items2.filter(item => item?.category?.ru != 'Общий');
    },
    // ===============  MATERIAL_GET_SECTION END ===============
    

















    // ===============  DOWNLOAD_EXCEL START ===============
    async downloadExcel() {
      let params = {}
      if(this.goods && this.goods.show_archive !== null && this.goods.show_archive !== undefined){
        if(this.goods.show_archive === true){
          params.show_archive = 1
        }else{
          params.show_archive = this.goods.show_archive
        }
      }

      await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD({ show_archive: params.show_archive, blob: true, excel: true}).then((res) => {

        const url = window.URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          })
        );
        const date = new Date();
        const fullDate = moment(date).format("DD-MM-YYYY");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fullDate);
        document.body.appendChild(link);
        link.click();

      });
    },
    async downloadExcel2() {
      let params = {}
      if(this.goods && this.goods.show_archive2 !== null && this.goods.show_archive2 !== undefined){
        if(this.goods.show_archive2 === true){
          params.show_archive = 1
        }else{
          params.show_archive = this.goods.show_archive2
        }
      }

      await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE({show_archive: params.show_archive2, blob: true, excel: true}).then((res) => {

        const url = window.URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          })
        );
        const date = new Date();
        const fullDate = moment(date).format("DD-MM-YYYY");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fullDate);
        document.body.appendChild(link);
        link.click();

      });
    },
    // ===============  DOWNLOAD_EXCEL END ===============


















    // ===============  ON_GOOD_SELECTED START ===============
    async onGoodSelected(value){
      // if(this.goods.title == '' || this.goods.title == null || this.goods.category == '' || this.goods.category == null){
        if(value && value.product && value.product.id && value.product.title && value.product.category && value.product.category.id && value.product.category.title){
          this.goods.title = {id: value.product.id, title: value.product.title}
          this.goods.category = {id: value.product.category.id, title: value.product.category.title}
        }

        let params = {}
        if(this.goods && this.goods.good_id && this.goods.good_id.id){
          params.good_id = this.goods.good_id.id
        } 

        if(this.goods && this.goods.show_archive !== null && this.goods.show_archive !== undefined){
          if(this.goods.show_archive === true){
            params.show_archive = 1
          }else{
            params.show_archive = this.goods.show_archive
          }
        }


        this.items1 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD(params)
        this.items1_total = this.items1.find(item => item.object == 'Общий');
        this.items1 = this.items1.filter(item => item.object != 'Общий');

      // }
    },
    async onGoodSelected2(value){
      // if(this.goods.title == '' || this.goods.title == null || this.goods.category == '' || this.goods.category == null){
        if(value && value.product && value.product.id && value.product.title && value.product.category && value.product.category.id && value.product.category.title){
          this.goods.title = {id: value.product.id, title: value.product.title}
          this.goods.category = {id: value.product.category.id, title: value.product.category.title}
        }

        let params = {}
        if(this.goods && this.goods.good_id && this.goods.good_id.id){
          params.good_id = this.goods.good_id.id
        } 
        
        if(this.goods && this.goods.storage_id && this.goods.storage_id.id){
          params.storage_id = this.goods.storage_id.id
        } 

        if(this.goods && this.goods.show_archive2 !== null && this.goods.show_archive2 !== undefined){
          if(this.goods.show_archive2 === true){
            params.show_archive = 1
          }else{
            params.show_archive = this.goods.show_archive2
          }
        }

        this.items2 = await this.FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE(params)
        this.items2_total = this.items2.find(item => item?.category?.ru == 'Общий');
        this.items2 = this.items2.filter(item => item?.category?.ru != 'Общий');
      // }
    },
    // ===============  ON_GOOD_SELECTED END ===============










    // ===============  SEARCH_SECTION START ===============
    async onSearch(query) {
      this.search = query;
      await this.FETCH_MATERIALS_TABLE_ID({
        product: this.goods && this.goods.title && this.goods.title.id ?
        this.goods.title.id : null,
        search: query,
        pagination: "number", 
      });
    },
    async onSearch1(query) {
      await this.FETCH_MATERIALS({
        search: query,
         pagination: "number",
        });
    },
    // ===============  SEARCH_SECTION END ===============









  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";





.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}






table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}
</style>
